/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { ArrowRightOutlined } from '@ant-design/icons'
import type { ICellRendererParams } from 'ag-grid-community'
import colors from '@sportninja/common/constants/appColors'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import type { TeamFinderRow } from '@sportninja/common/features/teamFinder/resultRow'
import { buildRegistrationUrl } from '@sportninja/common/features/registration/registrationUrlParams'
import { paragraphXSmall, weightSemiBold } from 'src/components/css'

/**
 * The card's "View & Register" call to action, as its own column. Pinned right
 * in the grid so the row's one action stays reachable however far the reader
 * has scrolled sideways.
 */
const RegisterCell = ({ data }: ICellRendererParams<TeamFinderRow>) => {
  if (!data?.scheduleId) {
    return null
  }
  return (
    <a
      css={ctaStyle}
      href={buildRegistrationUrl(data.scheduleId, { teamId: data.teamId })}
      target='_blank'
      rel='noopener noreferrer'
    >
      {capitalizeWords('View & Register')} <ArrowRightOutlined />
    </a>
  )
}

export default RegisterCell

// Full cell height so the action lines up with the row's other values.
const ctaStyle = css`
  ${paragraphXSmall};
  ${weightSemiBold};
  color: ${colors.PRIMARY};
  display: flex;
  align-items: center;
  height: 100%;
  gap: 6px;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`
